import React from "react";
import { Navigate } from "react-router-dom";
import { usePermissions } from "../../../Hooks/usePermissions";

const ProfilePage = () => {
  const { currentUserId } = usePermissions();
  if (currentUserId == null) return <Navigate to="/" replace />;
  return <Navigate to={`/admin/update/${currentUserId}`} replace />;
};

export default ProfilePage;
